/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from "react";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import POSHeader from "components/POSHeader";
import CustomInputSearch from "components/fragments/CustomInputSearch";
import CustomerInfo from "./CustomerInfo";
import BillDetails from "./BillDetails";
import ModalPinCancelBill from "components/modals/ModalPinCancelBill";
import ModalPinVoidBill from "components/modals/ModalPinVoidBill";
import ModalVoidBill from "components/modals/ModalVoidBill";
import StockConfirmationVoid from "components/modals/StockConfirmationVoid";
import ModalSuccessCancleBill from "components/modals/ModalSuccessCancleBill";
import ModalVoidSuccess from "components/modals/ModalVoidSuccess";
import ModalSuccess from "components/modals/ModalSuccess";
import ModalCancelBill from "components/modals/ModalCancelBill";
import ModalReturnProduct from "components/modals/ModalReturnProduct";
import ModalReturnProductSuccess from "components/modals/ModalReturnProductSuccess";
import ModalDeleteBillConfirm from "components/modals/ModalDeleteBillConfirm";
import ModalRecallBill from "components/modals/ModalRecallBill";
import ReceiptPrintPopup from "components/modals/printing-forms/ModalReceiptPrint";
import clipboard_remove from "img/clipboard_remove.png";
import { posHandler, authHandler, billHandler } from "../../../redux/handlers";
import ModalVoidBillPrint from "../../../components/modals/printing-forms/ModalVoidBillPrint";

import {
  setPaymentResponse,
  setRecallOrderData,
  setRecallOrderId,
} from "../../../redux/slices/bill.slice";

const formatNumber = (value) => {
  if (value === undefined || value === null || value === "-") return "-";
  const num = typeof value === "string" ? parseFloat(value) : value;
  return num.toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const BILL_STATUS = {
  OPEN: 1,
  PENDING: 2,
  COMPLETED: 3,
  CANCELED: 4,
  RETURNED: 5,
  VOIDED: 6,
};

const DELIVERY_OPTIONS = [
  { value: "", label: "ทั้งหมด" },
  { value: 1, label: "ทานที่ร้าน" },
  { value: 2, label: "กลับบ้าน" },
  { value: 3, label: "เดลิเวอรี่" },
];

const BILL_STATUS_MAP = new Map([
  ["", null],
  ["OPEN", 1],
  ["PENDING", 1],
  ["COMPLETED", 3],
  ["CANCELED", 4],
  ["RETURNED", 5],
  ["VOIDED", 6],
]);

const REVERSED_BILL_STATUS_MAP = new Map([
  [null, ""],
  [1, "PENDING"],
  [2, "PENDING"],
  [3, "COMPLETED"],
  [4, "CANCELED"],
  [5, "RETURNED"],
  [6, "VOIDED"],
]);

const DELIVERY_OPTIONS_MAP = new Map([
  ["DINE_IN", 1],
  ["TAKEAWAY", 2],
  ["DELIVERY", 3],
]);

const INITIAL_RETURN_PRODUCT = {
  product: [],
  reason: "",
  note: "",
  stock: 0,
};

const INITIAL_BILL_CANCEL_DATA = {
  billID: "",
  reason: "",
  note: "",
};

const INITIAL_VOID_DATA = {
  reason_id: null,
  reason_label: "",
  note: "",
};

const INITIAL_BILL_STATUS_COUNTS = {
  open: 0,
  pending: 0,
  completed: 0,
  CANCELED: 0,
  return: 0,
  total: 0,
};

const INITIAL_MODAL_STATES = {
  pinOpen: false,
  successOpen: false,
  cancleBillOpen: false,
  returnProduct: false,
  returnProductSuccess: false,
  deleteBillConfirm: false,
  deleteSuccessOpen: false,
  recallBillConfirm: false,
  printModalOpen: false,
  voidPinOpen: false,
  voidBillOpen: false,
  voidSuccessOpen: false,
  stockConfirmationVoid: false,
  voidPrintModalOpen: false,
};

const isToday = (dateString) => {
  if (!dateString) return false;

  const date = new Date(dateString);
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export default function Bill() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pos, branch } = useSelector((state) => state.pos);
  const { businessSlug } = useParams();
  const location = useLocation();
  const autoSelectedRef = useRef(false);
  const branchPOSSellingId = localStorage.getItem("branchPOSSelling");
  const currentBranchPOSId = localStorage.getItem("branchPOSId");
  const currentBranchId = localStorage.getItem("branchId");
  const billItem = useSelector((state) => state.bill.billItem);
  const isLoading = useSelector((state) => state.common.isLoading);

  const [modalStates, setModalStates] = useState(INITIAL_MODAL_STATES);
  const [billList, setBillList] = useState([]);
  const [selectedBill, setSelectedBill] = useState(null);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [productToReturn, setProductToReturn] = useState(
    INITIAL_RETURN_PRODUCT
  );
  const [returnProduct, setReturnProduct] = useState({
    stock: "0",
    reason: "",
    reason_id: null,
    note: "",
  });
  const [billCancellationData, setBillCancellationData] = useState(
    INITIAL_BILL_CANCEL_DATA
  );
  const [pointOfSaleInfo, setPointOfSaleInfo] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [deliveryTypeFilter, setDeliveryTypeFilter] = useState("");
  const [billStatusFilter, setBillStatusFilter] = useState("");
  const [orderNumberFilter, setOrderNumberFilter] = useState("");
  const [filteredBills, setFilteredBills] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isRecalling, setIsRecalling] = useState(false);
  const [billStatusCounts, setBillStatusCounts] = useState(
    INITIAL_BILL_STATUS_COUNTS
  );
  const [isProcessingCancellation, setIsProcessingCancellation] =
    useState(false);
  const [returnResponse, setReturnResponse] = useState(null);
  const [voidData, setVoidData] = useState(INITIAL_VOID_DATA);
  const [voidResponse, setVoidResponse] = useState(null);
  const [verifiedPin, setVerifiedPin] = useState(null);

  const updateModalState = (modalName, value) => {
    setModalStates((prev) => ({ ...prev, [modalName]: value }));
  };

  const handlePrintBill = () => {
    updateModalState("printModalOpen", true);
  };

  const handlePrintComplete = () => {
    updateModalState("printModalOpen", false);
  };

  const handlePrintVoidBill = () => {
    updateModalState("voidPrintModalOpen", true);
  };

  const handleVoidPrintComplete = () => {
    updateModalState("voidPrintModalOpen", false);
  };

  const refreshBillData = async () => {
    try {
      setBillStatusFilter("");
      setDeliveryTypeFilter("");
      setOrderNumberFilter("");

      const branchPosId = localStorage.getItem("branchPOSId");
      await dispatch(
        billHandler.getBill(
          businessSlug,
          branchPOSSellingId,
          selectedDate || new Date().toISOString().split("T")[0],
          branchPosId
        )
      );

      await fetchPendingOrders();

      const response = await dispatch(
        billHandler.getBillById(businessSlug, selectedBill.billID)
      );
      if (response) {
        const mappedBillItem = mapBillItem(response);
        setSelectedBill(mappedBillItem);
        setCustomerInfo(
          mappedBillItem.customerID ? mappedBillItem.customerID : null
        );
      }
    } catch (error) {
      console.error("Error refreshing bill data:", error);
    }
  };

  const handleDateChange = (event, picker) => {
    const pickedDate = picker.startDate.format("YYYY-MM-DD");
    setSelectedDate(pickedDate);
  };

  const handleBillSelection = async (billItem) => {
    try {
      dispatch(setPaymentResponse(null));

      const isFromPendingOrders = billList.some(
        (item) => item.billID === billItem.billID
      );

      if (isFromPendingOrders) {
        setSelectedBill(billItem);
        setCustomerInfo(billItem.customerID ? billItem.customerID : null);
        return;
      }

      const response = await dispatch(
        billHandler.getBillById(businessSlug, billItem.billID)
      );

      if (response) {
        const mappedBillItem = mapBillItem(response);
        setSelectedBill(mappedBillItem);
        setCustomerInfo(
          mappedBillItem.customerID ? mappedBillItem.customerID : null
        );
      } else {
        setSelectedBill(billItem);
        setCustomerInfo(billItem.customerID ? billItem.customerID : null);
      }
    } catch (error) {
      console.error("Error fetching bill details:", error);
      setSelectedBill(billItem);
      setCustomerInfo(billItem.customerID ? billItem.customerID : null);
    }
  };

  const handleBillCancellation = () => {
    updateModalState("cancleBillOpen", true);

    setBillCancellationData((prev) => ({ ...prev, billID: 1 }));
  };

  const handleBillDeletion = () => {
    updateModalState("deleteBillConfirm", true);
  };

  const handleBillDeletionSuccess = () => {
    setSelectedBill(null);
    fetchPendingOrders();
    updateModalState("successOpen", true);
  };

  const handleConfirmBillDeletion = async () => {
    if (!selectedBill || !selectedBill.billID) {
      console.error("No bill selected for deletion");
      return;
    }

    setIsDeleting(true);
    try {
      await dispatch(
        posHandler.updateHoldOrder(businessSlug, selectedBill.billID, {
          status: "CANCEL",
        })
      );

      await fetchPendingOrders();
      updateModalState("deleteBillConfirm", false);
      handleBillDeletionSuccess();
    } catch (error) {
      console.error("Error deleting bill:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleBillRecall = async () => {
    if (selectedBill) {
      const isFromPendingOrders = billList.some(
        (item) => item.billID === selectedBill.billID
      );
      if (
        selectedBill.billStatus === BILL_STATUS.PENDING &&
        isFromPendingOrders
      ) {
        await handleConfirmBillRecall();
      } else if (
        selectedBill.billStatus === BILL_STATUS.OPEN &&
        !isFromPendingOrders
      ) {
        await handleConfirmBillRecall();
      }
    }
  };

  const handleConfirmBillRecall = async () => {
    if (!selectedBill || !selectedBill.billID) {
      console.error("No bill selected for recall");
      return;
    }

    if (selectedBill?.notFromHold) {
      dispatch(setRecallOrderId(selectedBill.order_id));
      navigate(`/${businessSlug}/`);
      return;
    }

    setIsRecalling(true);
    try {
      await dispatch(
        posHandler.updateHoldOrder(businessSlug, selectedBill.billID, {
          status: "ROLLBACK",
        })
      );

      dispatch(setRecallOrderData(selectedBill.rawOrderData));

      navigate(`/${businessSlug}/`);
    } catch (error) {
      console.error("Error recalling bill:", error);
    } finally {
      setIsRecalling(false);
    }
  };

  const handleReturnSuccess = async (response) => {
    setReturnResponse(response);
    await refreshBillData();
    updateModalState("returnProductSuccess", true);
  };

  const mapBillItem = (item, filter, count) => {
    if (filter === undefined) {
      if (count !== undefined) {
        count.total += 1;
        if (item.status === "OPEN") {
          count.open += 1;
        } else if (item.status === "PENDING") {
          count.open += 1;
        } else if (item.status === "COMPLETED") {
          count.completed += 1;
        } else if (item.status === "CANCELED") {
          count.CANCELED += 1;
        } else if (item.status === "RETURNED") {
          count.return += 1;
        } else if (item.status === "VOIDED") {
          count.CANCELED += 1;
        }
      }
    }
    let billStatus = BILL_STATUS_MAP.get(item.status);

    return {
      billID: item.id,
      order_id: item.order_id,
      receiptNo: item.receipt_no || "-",
      refund_no: item.refund_no || null,
      void_no: item.void_no || null,
      voided_at: item.voided_at,
      userBusinessGroup: item.userBusinessGroup,
      billVoidRemark: item.billVoidRemark,
      remark: item.remark,
      notFromHold: true,
      pos: item.order.branchPosSelling.branchPos.name,
      billStatus,
      status: item.status,
      staff:
        item.userBusinessGroup.first_name +
        " " +
        item.userBusinessGroup.last_name,
      customerID: item.member_id,
      customerName: "",
      orderNo: item.order.code,
      orderDate: new Date(item.created_at).toLocaleTimeString("en-US", {
        hour12: true,
        hour: "numeric",
        minute: "2-digit",
      }),
      billOpenTime: null,
      billPaymentTime: null,
      tableID: "",
      tableName: "",
      zone: "",
      delivery: DELIVERY_OPTIONS_MAP.get(item.order.order_type),
      taxInvoice: null,
      billReturned: item.billReturned || [],
      created_at: item.created_at,
      order: item.order,
      product: item.billItems.map((billItem) => ({
        id: billItem.orderItem.id.toString(),
        billItemId: billItem.id,
        productID: billItem.orderItem.product_id,
        productImage: billItem.orderItem.product?.image_path || null,
        productName:
          billItem.orderItem.product?.name || billItem.orderItem.item_name,
        productPrice: billItem.orderItem.price,
        productPricePerPiece: billItem.orderItem?.product?.price || 0,
        productSumPrice: billItem.price,
        productQty: billItem.quantity,
        productStatus:
          billItem.orderItem?.status_kitchen === "ORDER_CANCEL" ? 4 : 0,
        optionnote: billItem.orderItem.orderProductAnnotation
          ? billItem.orderItem.orderProductAnnotation.map((annotation) => ({
              listID: annotation.id.toString(),
              itemName: annotation.productAnnotationItem.name,
            }))
          : [],
        optionproduct: billItem.orderItem.orderProductOption
          ? billItem.orderItem.orderProductOption.map((option) => ({
              listID: option.id.toString(),
              itemName: option.productOptionItem.name,
              price: option.productOptionItem.price,
              qty: option.qty,
            }))
          : [],
        optionstandard: billItem.orderItem.orderProductSpecificOption
          ? billItem.orderItem.orderProductSpecificOption.map((option) => ({
              listID: option.id.toString(),
              itemName: option.productSpecificOptionItem.name,
              price: option.productSpecificOptionItem.price,
              qty: option.qty,
            }))
          : [],
        note: billItem.orderItem.remark || "",
      })),
      orderPrice: {
        final_profit_loss_rounded: item.final_profit_loss_rounded,
        taxable_amount: item.taxable_amount,
        sumprice:
          item.final_profit_loss_rounded ||
          item.total_price ||
          item.grand_total,
        discount: item.discount_amount,
        vat: item.vat,
        net: Number(item.final_amount) || Number(item.total_price),
      },
      payment: item.payment,
      total_price: item.total_price,
      total_before_discount: item.total_before_discount,
      discount_amount: item.discount_amount,
      discount_points: item.discount_points,
      total_after_discount: item.total_after_discount,
      service_charge: item.service_charge,
      service_charge_percent: item.service_charge_percent,
      taxable_amount: item.taxable_amount,
      vat: item.vat,
      grand_total: item.grand_total,
      credit_card_fee: item.credit_card_fee,
      vat_on_fee: item.vat_on_fee,
      final_amount: item.final_amount,
      final_payment_amount: item.final_payment_amount,
      additional_data: item.additional_data || {
        point: {
          spend: 0,
          earned: 0,
          remain: 0,
          total: 0,
        },
      },
      member: item.member || null,
      rawOrderData: {
        product: item.billItems.map((billItem) => ({
          id: billItem.orderItem.id.toString(),
          productID: billItem.orderItem.product_id,
          productImage: billItem.orderItem.product?.image_path || null,
          productName:
            billItem.orderItem.item_name || billItem.orderItem.product?.name,
          productPrice: billItem.orderItem.price,
          productSumPrice: billItem.price,
          productQty: billItem.quantity,
          productStatus: 0,
          optionnote: billItem.orderItem.orderProductAnnotation
            ? billItem.orderItem.orderProductAnnotation.map((annotation) => ({
                listID: annotation.id.toString(),
                itemName: annotation.productAnnotationItem.name,
              }))
            : [],
          optionproduct: billItem.orderItem.orderProductOption
            ? billItem.orderItem.orderProductOption.map((option) => ({
                listID: option.id.toString(),
                itemName: option.productOptionItem.name,
                price: option.productOptionItem.price,
              }))
            : [],
          optionstandard: billItem.orderItem.orderProductSpecificOption
            ? billItem.orderItem.orderProductSpecificOption.map((option) => ({
                listID: option.id.toString(),
                itemName: option.productSpecificOptionItem.name,
                price: option.productSpecificOptionItem.price,
              }))
            : [],
          note: billItem.orderItem.remark || "",
          displayPrice: billItem.price,
        })),
        orderNo: item.order.code,
        tableID: "",
        orderPrice: {
          taxable_amount: item.taxable_amount,
          sumprice: item.total_price,
          discount: item.discount_amount,
          vat: item.vat,
          net: item.final_amount || item.total_price,
        },
      },
    };
  };

  const convertOrdersToBillFormat = (pendingOrders, pointOfSaleData) => {
    if (!pendingOrders) return [];

    return pendingOrders.map((pendingOrder) => {
      const orderDetails = JSON.parse(pendingOrder.data);

      const orderStatusMapping = {
        PENDING: BILL_STATUS.PENDING,
        COMPLETED: BILL_STATUS.COMPLETED,
        CANCELED: BILL_STATUS.CANCELED,
      };

      const deliveryTypeMapping = {
        DINE_IN: 1,
        TAKEAWAY: 2,
        DELIVERY: 3,
      };

      const posTerminalName =
        pointOfSaleData &&
        Array.isArray(pointOfSaleData) &&
        pointOfSaleData.length > 0
          ? pointOfSaleData[0].name
          : "Unknown POS";

      let employeeName = "";
      if (
        pointOfSaleData &&
        pointOfSaleData.length > 0 &&
        pointOfSaleData[0].branchPosSelling &&
        pointOfSaleData[0].branchPosSelling.length > 0
      ) {
        if (pointOfSaleData[0].userBusinessGroup) {
          const { first_name, last_name } =
            pointOfSaleData[0].userBusinessGroup;
          employeeName = `${first_name || ""} ${last_name || ""}`.trim();
        } else {
          const { first_name, last_name } =
            pointOfSaleData[0].branchPosSelling[0].userBusinessGroup;
          employeeName = `${first_name || ""} ${last_name || ""}`.trim();
        }
      }

      const orderItems = orderDetails.product
        ? orderDetails.product.map((productItem) => ({
            id: productItem.id,
            productID: productItem.productID,
            productImage: productItem.productImage,
            productName: productItem.productName,
            productPrice: productItem.productPrice.toString(),
            productSumPrice: parseFloat(productItem.productSumPrice),
            productQty: productItem.productQty,
            productStatus: productItem.productStatus,
            optionnote: productItem.annotationOptions || [],
            optionproduct: productItem.specificOptions || [],
            optionstandard: productItem.standardOptions || [],
            note: productItem.note || "",
          }))
        : [];

      return {
        billID: pendingOrder.id,
        receiptNo: "-",
        pos: posTerminalName,
        billStatus:
          orderStatusMapping[pendingOrder.status] || BILL_STATUS.PENDING,
        staff: employeeName || "-",
        memberID: orderDetails.memberID,
        customerName: orderDetails.memberName || "",
        orderNo: "-",
        orderDate: new Date(pendingOrder.created_at).toLocaleDateString(
          "th-TH"
        ),
        billOpenTime: null,
        billPaymentTime: null,
        tableID: orderDetails.tableID || "",
        tableName: orderDetails.tableDetails?.tableNo || "",
        zone: orderDetails.tableDetails?.zoneName || "",
        delivery: deliveryTypeMapping[pendingOrder.order_type] || 1,
        taxInvoice: null,
        product: orderItems,
        orderPrice: orderDetails.orderPrice || {
          sumprice: 0,
          discount: 0,
          vat: 0,
          net: 0,
        },
        payment: orderDetails.payment,
        rawOrderData: orderDetails,
        created_at: pendingOrder.created_at,
      };
    });
  };

  const fetchPendingOrders = async (posTerminalData) => {
    try {
      if (
        branch?.employee_info?.userBusinessGroup?.branchPosSelling &&
        branch?.employee_info?.userBusinessGroup?.branchPosSelling.length > 0
      ) {
        const lastIndex =
          branch.employee_info.userBusinessGroup.branchPosSelling.length - 1;
        const branchPosSelling =
          branch?.employee_info?.userBusinessGroup?.branchPosSelling[lastIndex];
        const response = await dispatch(
          posHandler.getHoldOrders(
            businessSlug,
            selectedDate,
            branchPosSelling.id
          )
        );
        const currentPosTerminalInfo = posTerminalData || pointOfSaleInfo;
        const formattedBills = convertOrdersToBillFormat(
          response,
          currentPosTerminalInfo
        );
        setBillList(formattedBills);
      }
    } catch (error) {
      console.error("Error fetching pending orders:", error);
    }
  };

  const handleFetchBillForPrint = useCallback(async () => {
    if (businessSlug && selectedBill?.billID) {
      try {
        await dispatch(
          billHandler.getBillById(businessSlug, selectedBill.billID)
        );
      } catch (error) {
        console.error("Error fetching bill for print:", error);
      }
    }
  }, [businessSlug, selectedBill?.billID, dispatch]);

  const handlePrintFromVoidModal = useCallback(() => {
    updateModalState("voidPrintModalOpen", true);
  }, []);

  const renderStatusFilterButton = (statusValue, label, count) => (
    <button
      type="button"
      className="btn btn-bill-status me-2"
      style={
        billStatusFilter === statusValue
          ? {
              background: "#2DC76D",
              color: "#FFF",
              border: "1px solid #2DC76D",
            }
          : {}
      }
      onClick={() => setBillStatusFilter(statusValue)}
    >
      {label} ({count})
    </button>
  );

  const renderBillCard = (billItem, index) => {
    const isSelected =
      billItem.billID === selectedBill?.billID &&
      billItem.billStatus === selectedBill?.billStatus;

    const isCompletedBill = billItem.billStatus === BILL_STATUS.COMPLETED;
    const isCANCELEDBill = billItem.billStatus === BILL_STATUS.CANCELED;
    const isReturnedBill = billItem.billStatus === BILL_STATUS.RETURNED;
    const isVoidedBill = billItem.billStatus === BILL_STATUS.VOIDED;
    const isFromPendingOrders = billList.some(
      (item) => item.billID === billItem.billID
    );

    const hasReturns =
      billItem.billReturned && billItem.billReturned.length > 0;

    let displayNumber;
    if (isReturnedBill && billItem.refund_no) {
      displayNumber = billItem.refund_no;
    } else if (isVoidedBill && billItem.void_no) {
      displayNumber = billItem.void_no;
    } else if (isCompletedBill) {
      displayNumber = billItem.receiptNo;
    } else {
      displayNumber = billItem.orderNo;
    }

    const deliveryTypeMap = {
      1: { text: "ทานที่ร้าน", className: "dl2" },
      2: { text: "กลับบ้าน", className: "dl1" },
      3: { text: "เดลิเวอรี่", className: "dl3" },
    };

    return (
      <div
        className={`card card-bill mb-2 ${isSelected ? "active" : ""}`}
        key={index}
        onClick={() => handleBillSelection(billItem)}
      >
        <div className="d-flex align-items-center mb-1">
          <div className="me-auto text-12 text-[#B6BBC6]">{displayNumber}</div>
          {billItem.billStatus === BILL_STATUS.OPEN && !isFromPendingOrders && (
            <div className="bill-status-s2">เปิดบิลอยู่</div>
          )}
          {billItem.billStatus === BILL_STATUS.PENDING &&
            isFromPendingOrders && <div className="bill-status-s1">พักบิล</div>}
          {billItem.billStatus === BILL_STATUS.COMPLETED &&
            !isCompletedBill && <div className="bill-status-s1">สำเร็จ</div>}
          {billItem.billStatus === BILL_STATUS.CANCELED && !isCANCELEDBill && (
            <div className="bill-status-s1">ยกเลิก</div>
          )}
          {billItem.billStatus === BILL_STATUS.RETURNED && (
            <div className="bill-status-s4">คืนสินค้า</div>
          )}
          {isVoidedBill && (
            <div
              style={{
                display: "inline-block",
                backgroundColor: "transparent",
                border: "2px solid #FF0000",
                borderRadius: "12px",
                color: "#FF0000",
                padding: "2px 10px",
                fontSize: "10px",
                fontWeight: "600",
                textAlign: "center",
                minWidth: "40px",
              }}
            >
              VOID
            </div>
          )}
          {isCompletedBill && (
            <>
              {hasReturns && (
                <div className="bill-status-s4 me-2">คืนสินค้า</div>
              )}
              {billItem.taxInvoice && (
                <div className="text-[#FF6B00] text-12 me-2">ออกใบกำกับ</div>
              )}
              <div className="bill-status-s3">สำเร็จ</div>
            </>
          )}
          {isCANCELEDBill && <div className="bill-status-s4">ยกเลิกรายการ</div>}
        </div>

        <div className="d-flex align-items-center text-16 text-[#061126] mb-1">
          <div
            className={`me-auto ${
              isCANCELEDBill || isVoidedBill ? "tc-1" : ""
            }`}
          >
            {billItem.member
              ? `${billItem.member.first_name_th || ""} ${
                  billItem.member.last_name_th || ""
                }`.trim()
              : billItem.customerName || "-"}
          </div>
          <div
            className={`${isCANCELEDBill || isVoidedBill ? "tc-1" : ""} ${
              billItem.billStatus === 5 || billItem.billStatus === 6
                ? "text-[#FF0000]"
                : ""
            }`}
          >
            {formatNumber(Number(billItem.orderPrice.sumprice))}
          </div>
        </div>

        <div className="d-flex align-items-center justify-between">
          <div className="">
            <div className="me-2">
              {billItem.delivery && deliveryTypeMap[billItem.delivery] && (
                <div className={deliveryTypeMap[billItem.delivery].className}>
                  {deliveryTypeMap[billItem.delivery].text}
                  {billItem.order?.remark ? ` (${billItem.order.remark})` : ""}
                </div>
              )}
            </div>
            <div className="text-[#B6BBC6] fs-10 me-1 pt-[1px]">
              {billItem.tableName}
            </div>
          </div>
          <div className="text-[#B6BBC6] fs-10 pt-[1px]">
            {billItem.orderDate}
          </div>
        </div>
      </div>
    );
  };

  const renderBillActionButtons = () => {
    if (!selectedBill) return null;

    const {
      billStatus: currentStatus,
      billReturned,
      created_at,
    } = selectedBill;

    const isFromPendingOrders = billList.some(
      (item) => item.billID === selectedBill.billID
    );

    const isPendingBill =
      currentStatus === BILL_STATUS.PENDING && isFromPendingOrders;
    const isOpenBill =
      currentStatus === BILL_STATUS.OPEN && !isFromPendingOrders;
    const isCompletedBill = currentStatus === BILL_STATUS.COMPLETED;
    const isCanceledBill = currentStatus === BILL_STATUS.CANCELED;
    const isReturnedBill = currentStatus === BILL_STATUS.RETURNED;
    const isVoidedBill = currentStatus === BILL_STATUS.VOIDED;

    const isReturnAvailable =
      isCompletedBill &&
      billReturned &&
      billReturned.length === 0 &&
      isToday(created_at);

    return (
      <div className="pt-2 pb-2 d-flex justify-content-center">
        {isPendingBill && (
          <>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#FF731D] me-3"
              onClick={handleBillDeletion}
            >
              ลบบิล
            </button>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#2DC76D]"
              onClick={handleBillRecall}
              disabled={isLoading || isProcessingCancellation}
            >
              เรียกบิล
            </button>
          </>
        )}

        {isOpenBill && (
          <>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#FF731D] me-3"
              onClick={handleBillCancellation}
            >
              ยกเลิก
            </button>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#2DC76D] me-3"
              onClick={handleBillRecall}
              disabled={isLoading || isProcessingCancellation}
            >
              เรียกบิล
            </button>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#2192FF]"
              onClick={handlePrintBill}
            >
              พิมพ์
            </button>
          </>
        )}

        {isCompletedBill && (
          <>
            {isReturnAvailable && (
              <button
                className="btn btn-x1 text-[#FFF] bg-[#FF731D] me-3"
                onClick={() => updateModalState("returnProduct", true)}
              >
                คืนสินค้า
              </button>
            )}
            <button
              className="btn btn-x1 text-[#FFF] bg-[#FF0000] me-3"
              onClick={() => {
                setVoidData(INITIAL_VOID_DATA);
                updateModalState("voidPinOpen", true);
              }}
            >
              ยกเลิก
            </button>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#2192FF]"
              onClick={handlePrintBill}
            >
              พิมพ์
            </button>
          </>
        )}

        {isReturnedBill && (
          <>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#FF731D] me-3"
              onClick={handleBillCancellation}
              disabled={true}
            >
              ยกเลิก
            </button>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#2DC76D] me-3"
              onClick={handleBillRecall}
              disabled={true}
            >
              เรียกบิล
            </button>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#FF0000]"
              onClick={handlePrintBill}
              disabled={true}
            >
              พิมพ์
            </button>
          </>
        )}

        {isCanceledBill && (
          <>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#FF731D] me-3"
              disabled
            >
              ยกเลิก
            </button>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#2DC76D] me-3"
              disabled
            >
              เรียกบิล
            </button>
            <button className="btn btn-x1 text-[#FFF] bg-[#2192FF]" disabled>
              พิมพ์
            </button>
          </>
        )}

        {isVoidedBill && (
          <>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#FF731D] me-3"
              disabled
            >
              ยกเลิก
            </button>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#2DC76D] me-3"
              disabled
            >
              เรียกบิล
            </button>
            <button
              className="btn btn-x1 text-[#FFF] bg-[#2192FF]"
              onClick={handlePrintVoidBill}
            >
              พิมพ์
            </button>
          </>
        )}
      </div>
    );
  };

  useEffect(() => {
    const date = new Date();
    setSelectedDate(date.toISOString().split("T")[0]);
  }, []);

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const [, , posTerminalResponse] = await Promise.all([
          dispatch(authHandler.getUserBusinessProfile(businessSlug)),
          dispatch(posHandler.getBranchInfo(businessSlug, currentBranchId)),
          dispatch(posHandler.getBranchPosById(businessSlug, currentBranchId)),
        ]);

        setPointOfSaleInfo(posTerminalResponse);
        await fetchPendingOrders(posTerminalResponse);
      } catch (error) {
        console.error("Error loading initial data:", error);
      }
    };

    if (businessSlug && currentBranchPOSId) {
      loadInitialData();
    }
  }, [businessSlug, currentBranchPOSId]);

  useEffect(() => {
    const filter = REVERSED_BILL_STATUS_MAP.get(billStatusFilter);

    const fetch = async () => {
      try {
        const branchPosId = localStorage.getItem("branchPOSId");
        await dispatch(
          billHandler.getBill(
            businessSlug,
            branchPOSSellingId,
            selectedDate || new Date().toISOString().split("T")[0],
            filter === undefined
              ? null
              : billStatusFilter === BILL_STATUS.CANCELED
              ? "CANCELED,VOIDED"
              : filter,
            branchPosId
          )
        );

        if (billStatusFilter === 2) {
          await fetchPendingOrders();
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetch();
  }, [businessSlug, currentBranchPOSId, selectedDate, billStatusFilter]);

  useEffect(() => {
    const filter = REVERSED_BILL_STATUS_MAP.get(billStatusFilter);
    let count = {
      open: 0,
      pending: 0,
      completed: 0,
      CANCELED: 0,
      return: 0,
      total: 0,
    };

    let updateBillItem = [];

    if (Array.isArray(billItem)) {
      updateBillItem = billItem?.map((item) =>
        mapBillItem(item, filter, count)
      );
    } else if (billItem && typeof billItem === "object") {
      updateBillItem = [mapBillItem(billItem, filter, count)];
    }

    let filteredUpdateBillItem = [...updateBillItem];

    if (deliveryTypeFilter !== "") {
      filteredUpdateBillItem = filteredUpdateBillItem.filter(
        (item) => item.delivery === deliveryTypeFilter
      );
    }

    if (orderNumberFilter !== "") {
      filteredUpdateBillItem = filteredUpdateBillItem.filter((item) =>
        item.orderNo.toLowerCase().includes(orderNumberFilter.toLowerCase())
      );
    }

    if (billStatusFilter !== "") {
      filteredUpdateBillItem = filteredUpdateBillItem.filter((item) => {
        if (billStatusFilter === BILL_STATUS.CANCELED) {
          return (
            item.billStatus === BILL_STATUS.CANCELED ||
            item.billStatus === BILL_STATUS.VOIDED
          );
        }
        return item.billStatus === billStatusFilter;
      });
    }

    let filteredBillList = [];
    if (Array.isArray(billList) && billList.length > 0) {
      filteredBillList = [...billList];

      if (deliveryTypeFilter !== "") {
        filteredBillList = filteredBillList.filter(
          (item) => item.delivery === deliveryTypeFilter
        );
      }

      if (orderNumberFilter !== "") {
        filteredBillList = filteredBillList.filter((item) =>
          item.orderNo.toLowerCase().includes(orderNumberFilter.toLowerCase())
        );
      }

      if (billStatusFilter !== "") {
        if (
          billStatusFilter !== BILL_STATUS.PENDING &&
          billStatusFilter !== ""
        ) {
          filteredBillList = [];
        }
      }

      if (filter === undefined) {
        filteredBillList.forEach(() => {
          count.pending++;
          count.total++;
        });
      }
    }

    const comboList = [...filteredUpdateBillItem, ...filteredBillList];
    setFilteredBills(comboList);

    if (filter === undefined) {
      setBillStatusCounts(count);
    }
  }, [
    billItem,
    billList,
    billStatusFilter,
    deliveryTypeFilter,
    orderNumberFilter,
  ]);

  useEffect(() => {
    const style = document.createElement("style");

    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className="bg-white">
      <POSHeader isNotify={true} />
      <div className="pl-[min(2.15vw,22px)] pt-[min(2.15vw,22px)]">
        <div className="row gx-3">
          <div className="col-4">
            <div
              style={{
                width: "100%",
                borderRadius: "8px",
                background: "rgba(244, 244, 244, 0.60)",
                padding: "5px",
              }}
            >
              <div className="pe-4 pt-2">
                <div className="pe-3">
                  <DateRangePicker
                    initialSettings={{ singleDatePicker: true }}
                    onApply={handleDateChange}
                  >
                    <input
                      type="text"
                      className="form-control input-calendar mb-2"
                      value={selectedDate || ""}
                    />
                  </DateRangePicker>
                </div>
                <div
                  className="fs-10 fw-light mb-3"
                  style={{ color: "rgba(109, 120, 141, 0.80)" }}
                >
                  ข้อมูลจะแสดงย้อนหลังสูงสุด 1 เดือน
                </div>

                <div className="d-flex align-items-center mb-3">
                  <div className="form-select-image me-2">
                    <Select
                      className={`selectedimg select-arrow selectedimg-${deliveryTypeFilter}`}
                      defaultValue={DELIVERY_OPTIONS[0]}
                      options={DELIVERY_OPTIONS}
                      onChange={(e) => setDeliveryTypeFilter(e.value)}
                      value={DELIVERY_OPTIONS.filter(
                        (item) => item.value === deliveryTypeFilter
                      )}
                      placeholder=""
                    />
                  </div>
                  <div
                    className="fs-14 fw-500 text-white px-3 py-1 ms-2"
                    style={{ borderRadius: "8px", background: "#FF731D" }}
                  >
                    {pos && pos.length > 0 ? pos[0].name : ""}
                  </div>
                </div>

                <CustomInputSearch
                  inputprops={{
                    type: "text",
                    className: "search-input text-12 w-100 pt-2 mb-3",
                    placeholder: "ค้นหาหมายเลขออเดอร์",
                    min: 0,
                  }}
                  onKeyUp={(e) => setOrderNumberFilter(e.target.value)}
                />
              </div>

              <div
                className="bx-bill pe-2"
                style={{ height: "calc(100vh - 285px)" }}
              >
                {filteredBills?.map(renderBillCard)}
              </div>
            </div>
          </div>

          <div className="col">
            <div className="mb-3">
              {renderStatusFilterButton("", "ทั้งหมด", billStatusCounts.total)}
              {renderStatusFilterButton(
                BILL_STATUS.OPEN,
                "ที่เปิดอยู่",
                billStatusCounts.open
              )}
              {renderStatusFilterButton(
                BILL_STATUS.COMPLETED,
                "สำเร็จ",
                billStatusCounts.completed
              )}
              {renderStatusFilterButton(
                BILL_STATUS.PENDING,
                "บิลที่พัก",
                billStatusCounts.pending
              )}
              {renderStatusFilterButton(
                BILL_STATUS.CANCELED,
                "ยกเลิก",
                billStatusCounts.CANCELED
              )}
              {renderStatusFilterButton(
                BILL_STATUS.RETURNED,
                "คืนสินค้า",
                billStatusCounts.return
              )}
            </div>

            {selectedBill ? (
              <div className="row gx-3">
                <div className="col-6">
                  {<BillDetails billdata={selectedBill} />}
                </div>

                <div className="col-6">
                  <div
                    className="ps-3 py-2 d-flex flex-column"
                    style={{
                      borderRadius: "8px",
                      background: "#FFF",
                      boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.14)",
                    }}
                  >
                    <div
                      className="overflow-auto"
                      style={{ height: "calc(100vh - 220px)" }}
                    >
                      <CustomerInfo
                        customer={customerInfo}
                        billdata={selectedBill}
                      />
                    </div>

                    {renderBillActionButtons()}
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ height: "calc(100vh - 150px)" }}
              >
                <div className="text-center">
                  <img src={clipboard_remove} alt="No bills found" />
                  <div className="mt-3 text-[#6D788D]">ไม่พบรายการ</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <ModalCancelBill
        modalOpenObj={{
          modalOpen: modalStates.cancleBillOpen,
          setModalOpen: (value) => updateModalState("cancleBillOpen", value),
        }}
        modalPinOpenObj={{
          modalOpen: modalStates.pinOpen,
          setModalOpen: (value) => updateModalState("pinOpen", value),
        }}
        billcancleObj={{
          billcancledata: billCancellationData,
          setBillcancledata: setBillCancellationData,
        }}
      />

      <ModalPinCancelBill
        modalOpenObj={{
          modalOpen: modalStates.pinOpen,
          setModalOpen: (value) => updateModalState("pinOpen", value),
        }}
        modalSuccessOpenObj={{
          modalOpen: modalStates.successOpen,
          setModalOpen: (value) => updateModalState("successOpen", value),
        }}
        billcancleObj={{
          billcancledata: billCancellationData,
          setBillcancledata: setBillCancellationData,
        }}
        billId={selectedBill?.billID}
        businessSlug={businessSlug}
        currentBranchPOSId={currentBranchPOSId}
        refreshBillData={refreshBillData}
        setIsProcessingCancellation={setIsProcessingCancellation}
      />

      <ModalPinVoidBill
        modalOpenObj={{
          modalOpen: modalStates.voidPinOpen,
          setModalOpen: (value) => updateModalState("voidPinOpen", value),
        }}
        modalVoidOpenObj={{
          modalOpen: modalStates.voidBillOpen,
          setModalOpen: (value) => updateModalState("voidBillOpen", value),
        }}
        billId={selectedBill?.billID}
        businessSlug={businessSlug}
        onPinVerified={(pin) => setVerifiedPin(pin)}
      />

      <ModalVoidBill
        modalOpenObj={{
          modalOpen: modalStates.voidBillOpen,
          setModalOpen: (value) => updateModalState("voidBillOpen", value),
        }}
        modalStockConfirmationOpenObj={{
          modalOpen: modalStates.stockConfirmationVoid,
          setModalOpen: (value) =>
            updateModalState("stockConfirmationVoid", value),
        }}
        voidObj={{
          billvoiddata: voidData,
          setBillvoiddata: setVoidData,
        }}
        billId={selectedBill?.billID}
        businessSlug={businessSlug}
        refreshBillData={refreshBillData}
      />

      <StockConfirmationVoid
        modalOpenObj={{
          modalOpen: modalStates.stockConfirmationVoid,
          setModalOpen: (value) =>
            updateModalState("stockConfirmationVoid", value),
        }}
        modalSuccessOpenObj={{
          modalOpen: modalStates.voidSuccessOpen,
          setModalOpen: (value) => updateModalState("voidSuccessOpen", value),
        }}
        billdata={selectedBill}
        businessSlug={businessSlug}
        returnProduct={returnProduct}
        setReturnProduct={setReturnProduct}
        voidData={voidData}
        refreshBillData={refreshBillData}
        verifiedPin={verifiedPin}
        onVoidSuccess={(response) => {
          setVoidResponse(response);
          setVoidData(INITIAL_VOID_DATA);
          setReturnProduct({
            stock: "0",
            reason: "",
            reason_id: null,
            note: "",
          });
          setVerifiedPin(null);
        }}
      />

      <ModalReturnProduct
        modalOpenObj={{
          modalOpen: modalStates.returnProduct,
          setModalOpen: (value) => updateModalState("returnProduct", value),
        }}
        billdata={selectedBill}
        returnProduct={productToReturn}
        setReturnProduct={setProductToReturn}
        businessSlug={businessSlug}
        onReturnSuccess={handleReturnSuccess}
      />

      <ModalReturnProductSuccess
        modalOpenObj={{
          modalOpen: modalStates.returnProductSuccess,
          setModalOpen: (value) =>
            updateModalState("returnProductSuccess", value),
        }}
        returnResponse={returnResponse}
        onStartNewSale={() => {
          setReturnResponse(null);
        }}
      />

      <ModalDeleteBillConfirm
        modalOpenObj={{
          modalOpen: modalStates.deleteBillConfirm,
          setModalOpen: (value) => updateModalState("deleteBillConfirm", value),
        }}
        billdata={selectedBill}
        onConfirmDelete={handleConfirmBillDeletion}
        isLoading={isDeleting}
        onSuccess={handleBillDeletionSuccess}
      />

      <ModalRecallBill
        modalOpenObj={{
          modalOpen: modalStates.recallBillConfirm,
          setModalOpen: (value) => updateModalState("recallBillConfirm", value),
        }}
        billdata={selectedBill}
        onConfirmRecall={handleConfirmBillRecall}
        isLoading={isRecalling}
      />

      <ModalSuccessCancleBill
        modalOpenObj={{
          modalOpen: modalStates.deleteSuccessOpen,
          setModalOpen: (value) => updateModalState("deleteSuccessOpen", value),
        }}
      />

      <ModalSuccess
        modalOpenObj={{
          modalOpen: modalStates.successOpen,
          setModalOpen: (value) => updateModalState("successOpen", value),
        }}
        successMessage="ลบบิลสำเร็จ"
      />

      <ModalVoidSuccess
        modalOpenObj={{
          modalOpen: modalStates.voidSuccessOpen,
          setModalOpen: (value) => updateModalState("voidSuccessOpen", value),
        }}
        voidResponse={voidResponse}
        onFetchBillForPrint={handleFetchBillForPrint}
        onPrintBill={handlePrintFromVoidModal}
        onStartNewSale={() => {
          setVoidResponse(null);
        }}
      />

      <ReceiptPrintPopup
        isOpen={modalStates.printModalOpen}
        onPrintComplete={handlePrintComplete}
      />

      <ModalVoidBillPrint
        isOpen={modalStates.voidPrintModalOpen}
        onPrintComplete={handleVoidPrintComplete}
      />
    </div>
  );
}
